import React from "react";
import styles from "./SetOfMakes.module.scss";
import { SanityRawContent } from "../../model/common";
import BlockContent from "../../components/BlockContent/BlockContent";

interface SetOfMakesProps {
  node: {
    content: SanityRawContent;
  };
}

const SetOfMakes = ({ node: { content } }: SetOfMakesProps) => (
  <section className={styles.root}>
    <BlockContent content={content} />
  </section>
);

export default SetOfMakes;
